import { Card, Input, Tag } from 'antd';
import "./index.scss";
import { useEffect, useState } from 'react';
import { getLastResume } from '../../../../services/resumeService';
import qs from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { buildSearchObj, hasValidCachedSearch } from './service';
import { setSearchParams } from '../../../../store/reducers/Jobs/actions';
import Button from '../../../../components/forms/Button';
import { BUTTON_VARIANT_SECONDARY } from '../../../../components/forms/Button/constants';
import { FaSave } from '@react-icons/all-files/fa/FaSave'
import _ from 'lodash'


/**
 * 1. If there is a URL search query (location.pathname reducer)
 * 1.1. If it's equal to searchObj --> do nothing
 * 1.2 If it's diff than searchObj --> recreate searchObj based on the URL and save it --
 * 2. If there's no search query & searchObj is empty --> do nothing
 * 2.1 If there's no search query & searchObj exists --> use it
 */
const SearchCard = props => {
    const { userDetails } = props
    const { searchParams } = useSelector(({ JobsReducer }) => JobsReducer);
    const dispatch = useDispatch()
    const location = useLocation()
    const [showAllFilters, setShowAllFilters] = useState(false);
    const MAX_VISIBLE_FILTERS = 2;

    useEffect(() => {
        if (location.search) {
            const newSearchObj = buildSearchObj(location.search)
            const isParamsDiffThanUrl = JSON.stringify(newSearchObj) !== JSON.stringify(searchParams);
            if (isParamsDiffThanUrl) {
                dispatch(setSearchParams(newSearchObj))
            }
        }
        else if (localStorage.getItem('searchParams')) {
            let newSearchObj = localStorage.getItem('searchParams');
            newSearchObj = JSON.parse(newSearchObj);
            dispatch(setSearchParams(newSearchObj))
            updateQueryString(newSearchObj)
        }

    }, [location.search]);

    useEffect(() => {
        if (userDetails.featureFlags?.completedOnboarding) {
        if (userDetails && !location.search && !hasValidCachedSearch()) {
            const mostUpdatedResume = getLastResume(userDetails)
            if (mostUpdatedResume?.jobSearchQueries?.length) {
                const updatedParams = { ...searchParams, jobSearchQueries: [...mostUpdatedResume.jobSearchQueries, ...mostUpdatedResume.skills.map(s => s.name)] }
                dispatch(setSearchParams(updatedParams))
                updateQueryString(updatedParams)
            }
        }
        // if (!window.location.search) {
        //     const mostUpdatedResume = getLastResume(userDetails)
        //     if (mostUpdatedResume?.jobSearchQueries?.length) {
        //         const updatedParams = { ...searchParams, jobSearchQueries: [...mostUpdatedResume.jobSearchQueries, ...mostUpdatedResume.skills.map(s => s.name)] }
        //         setParams(updatedParams)
        //         updateQueryString(updatedParams)
        //     }
        // }
    }
    }, [userDetails])

    const onChange = (key, val) => {
        dispatch(setSearchParams({ ...searchParams, [key]: val }))
    }

    const onSubmit = async () => {
        if (!searchParams.query) return;
        
        // Split by comma, trim each keyword, and filter out empty strings
        const newKeywords = searchParams.query
            .split(',')
            .map(keyword => keyword.trim())
            .filter(keyword => keyword.length > 0);

        // Combine with existing tags and remove duplicates
        const newTags = _.uniq([...searchParams.jobSearchQueries, ...newKeywords]);
        
        const updatedParams = { ...searchParams, jobSearchQueries: newTags, query: "" }
        dispatch(setSearchParams(updatedParams));
        updateQueryString(updatedParams)
    }

    const onRemoveTag = tag => {
        const updatedParams = { ...searchParams, jobSearchQueries: searchParams.jobSearchQueries.filter(a => a !== tag) }
        dispatch(setSearchParams(updatedParams))
        updateQueryString(updatedParams)
    }
    const updateQueryString = (updatedParams) => {
        delete updatedParams.query;
        const queryString = qs.stringify(updatedParams, { arrayFormat: 'comma' });

        dispatch(push(`?${queryString}`))
    }

    const visibleFilters = searchParams?.jobSearchQueries || [];
    const shouldCollapse = visibleFilters.length > MAX_VISIBLE_FILTERS;
    const displayFilters = showAllFilters ? visibleFilters : visibleFilters.slice(0, MAX_VISIBLE_FILTERS);

    return (
        <div className="search-card">
            <Input.Search 
                className="search-input" 
                placeholder="Frontend Developer" 
                enterButton="AI Search" 
                loading={props.loading}
                onChange={e => onChange('query', e.target.value)} 
                onSearch={onSubmit} 
                value={searchParams.query}
            />
            <div className="search-note">
                Add as many keywords as you like separated by comma, hit enter to apply search
            </div>
            <br />
            <div className="filters">
                {searchParams?.jobSearchQueries?.length > 0 && (
                    <div className="tags">
                        {searchParams?.jobSearchQueries?.length > 0  && (
                            <div className="filter-summary">Applied {visibleFilters.length} filters</div>
                        )}
                        {displayFilters.map(query => (
                            <Tag key={query} closable onClose={() => onRemoveTag(query)}>{query}</Tag>
                        ))}
                        {shouldCollapse && (
                            <Button 
                                variant={BUTTON_VARIANT_SECONDARY} 
                                onClick={() => setShowAllFilters(!showAllFilters)}
                                className="show-more-less"
                            >
                                {showAllFilters ? 'Show less' : `Show all (${visibleFilters.length})`}
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default SearchCard